import { render, staticRenderFns } from "./Yardages-item.vue?vue&type=template&id=577cb741&scoped=true&lang=html"
import script from "./Yardages-item.vue?vue&type=script&lang=js"
export * from "./Yardages-item.vue?vue&type=script&lang=js"
import style0 from "./Yardages-item.vue?vue&type=style&index=0&id=577cb741&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577cb741",
  null
  
)

export default component.exports